// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type SearchContextProperties = {
  search_id: string;
  active_tab?: string;
  return_date?: string;
  days_to_departure?: number;
  departure_position_id: number;
  num_legs?: number;
  children: number;
  infants: number;
  senior: number;
  youths?: number;
  is_discount_card_applied?: boolean;
  passengers: string;
  arrival_position_id: number;
  tripDurationInDays?: number;
  departure_date: string;
  adults: number;
  round_trip: number;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/search_context/jsonschema/3-0-5';
export const searchContextName = 'search_context';
export class SearchContext extends BaseTrackingContext<SearchContextProperties> {
  constructor(properties: SearchContextProperties) {
    super(searchContextName, schema, properties);
  }
}
